import React from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const FormField = ({ label, value, onChange, variant = 'outlined', type = 'text', options }) => {
  if (type === 'select') {
    return (
      <FormControl variant={variant} fullWidth style={{ marginBottom: '20px' }}>
        <InputLabel>{label}</InputLabel>
        <Select value={value} onChange={onChange} label={label}>
          {options.map((option, index) => (
            <MenuItem key={index} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  return (
    <TextField
      label={label}
      value={value}
      onChange={onChange}
      variant={variant}
      fullWidth
      sx={{ marginBottom: '20px' }}
    />
  );
};

export default FormField;
